var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_552_7945",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#ECEFF1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_552_7945)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 60,
    r: 50,
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.533 88.5354V95.2137C87.533 95.9395 86.9435 96.5273 86.2193 96.5273H77.592C76.8662 96.5273 76.2783 95.9395 76.2783 95.2137V88.5354H87.533Z",
    fill: "#C8D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3386 88.5354V95.2137C33.3386 95.9395 32.7508 96.5273 32.025 96.5273H23.3977C22.6734 96.5273 22.084 95.9395 22.084 95.2137V88.5354H33.3386Z",
    fill: "#C8D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6249 96.5273H77.592C76.8662 96.5273 76.2783 95.9395 76.2783 95.2137V88.5354H80.2899V95.1924C80.2898 95.9296 80.8876 96.5273 81.6249 96.5273Z",
    fill: "#B9C3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4305 96.5273H23.3977C22.6734 96.5273 22.084 95.9395 22.084 95.2137V88.5354H26.094V95.1924C26.094 95.9296 26.6916 96.5273 27.4305 96.5273Z",
    fill: "#B9C3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6169 16.0044V89.2386C90.6169 90.3453 89.7204 91.242 88.6119 91.242H21.005C19.8967 91.242 19 90.3455 19 89.2386V16.0044C19 14.8977 19.8965 14.001 21.005 14.001H88.6119C89.7202 14.0011 90.6169 14.8977 90.6169 16.0044Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0134 91.242H21.005C19.8967 91.242 19 90.3455 19 89.2386V16.0044C19 14.8977 19.8965 14.001 21.005 14.001H25.0132C23.9065 14.001 23.0098 14.8975 23.0098 16.0044V89.2386C23.01 90.3455 23.9065 91.242 25.0134 91.242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1291 55.3067C74.1291 65.9441 65.5329 74.573 54.9088 74.6255C54.8759 74.6271 54.8414 74.6271 54.8087 74.6271H54.7561C44.1106 74.5993 35.4883 65.9587 35.4883 55.3067C35.4883 44.6367 44.1387 35.9863 54.8087 35.9863C54.9204 35.9863 55.0337 35.9879 55.1452 35.9913H55.1715C65.6742 36.1833 74.1291 44.7581 74.1291 55.3067Z",
    fill: "#C8D2DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7315 74.5138C56.1322 74.5796 55.5229 74.6173 54.9088 74.6255C54.8579 74.6255 54.8069 74.6271 54.7561 74.6271C44.1106 74.5993 35.4883 65.9587 35.4883 55.3067C35.4883 44.6367 44.1387 35.9863 54.8087 35.9863C54.9204 35.9863 55.0337 35.9879 55.1452 35.9913H55.1715C55.697 36.0062 56.2175 36.0423 56.7315 36.0996C47.0434 37.1374 39.4981 45.3395 39.4981 55.3067C39.4981 65.274 47.0434 73.4761 56.7315 74.5138Z",
    fill: "#B9C3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6034 55.3066C68.6034 62.9241 62.4276 69.0999 54.8085 69.0999C54.7772 69.0999 54.7477 69.0999 54.7166 69.0983C47.636 69.054 41.8248 63.6762 41.0925 56.7813C41.0416 56.2969 41.0137 55.8043 41.0137 55.3068C41.0137 47.7057 47.1615 41.5413 54.7577 41.5134H54.8085C54.8413 41.5134 54.8758 41.5134 54.9086 41.515C61.866 41.5626 67.6 46.7631 68.4835 53.4905C68.5623 54.085 68.6034 54.6909 68.6034 55.3066Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 30.9175V16.0044C19 14.8977 19.8965 14.001 21.005 14.001H88.6119C89.7202 14.0011 90.6169 14.8977 90.6169 16.0044V30.9176H19",
    fill: "#918291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.733 68.9423C56.0746 69.0424 55.4013 69.0967 54.7166 69.0983C47.636 69.054 41.8248 63.6762 41.0925 56.7813C41.0416 56.2969 41.0137 55.8043 41.0137 55.3068C41.0137 47.7057 47.1615 41.5413 54.7577 41.5134C54.8086 41.515 54.8596 41.515 54.9087 41.515C55.5261 41.5265 56.1337 41.579 56.7282 41.6695C50.1009 42.6793 45.0237 48.4003 45.0237 55.3068C45.0237 55.8043 45.0515 56.2969 45.1025 56.7813C45.764 63.0161 50.5818 68.0111 56.733 68.9423Z",
    fill: "#DBEAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8084 26.2095C56.8831 26.2095 58.565 24.5276 58.565 22.4529C58.565 20.3782 56.8831 18.6963 54.8084 18.6963C52.7336 18.6963 51.0518 20.3782 51.0518 22.4529C51.0518 24.5276 52.7336 26.2095 54.8084 26.2095Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6037 55.3067C68.6037 62.9242 62.4278 69.1001 54.8087 69.1001C54.7775 69.1001 54.748 69.1 54.7169 69.0984C47.6363 69.0541 41.825 63.6763 41.0928 56.7814C45.3573 56.563 45.5476 53.4989 50.0683 53.4563H50.1635C54.9453 53.4563 54.9453 56.7946 59.7285 56.7946C64.226 56.7946 64.4954 53.8456 68.4839 53.4908C68.5626 54.0851 68.6037 54.691 68.6037 55.3067Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7333 68.9424C56.0749 69.0425 55.4016 69.0968 54.7169 69.0984C47.6363 69.0541 41.825 63.6763 41.0928 56.7814C45.3573 56.563 45.5476 53.4989 50.0683 53.4563C50.8597 53.4613 51.5165 53.5598 52.0879 53.7174C49.3719 54.4679 48.6347 56.5993 45.1026 56.7816C45.7643 63.0162 50.5821 68.0112 56.7333 68.9424Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6014 55.1837C67.4344 55.9985 66.2388 56.795 63.9031 56.795C63.0817 56.795 62.4021 56.6965 61.8145 56.5329C64.4473 55.805 65.2221 53.7798 68.4845 53.491C68.5578 54.045 68.5978 54.6093 68.6014 55.1837Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8908 77.2872V84.6173C83.8908 84.9801 83.5968 85.2741 83.2339 85.2741H69.0318C68.669 85.2741 68.375 84.9801 68.375 84.6173V77.2872C68.375 76.9244 68.669 76.6304 69.0318 76.6304H83.2339C83.5969 76.6304 83.8908 76.9242 83.8908 77.2872Z",
    fill: "#C3DDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0533 85.2741H69.0318C68.669 85.2741 68.375 84.9801 68.375 84.6173V77.2872C68.375 76.9244 68.669 76.6304 69.0318 76.6304H73.0533C72.6838 76.6304 72.385 76.9292 72.385 77.297V84.6075C72.3848 84.9753 72.6838 85.2741 73.0533 85.2741Z",
    fill: "#A4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2371 19.3539V25.5526C83.2371 25.9154 82.9431 26.2094 82.5803 26.2094H66.7574C66.3946 26.2094 66.1006 25.9154 66.1006 25.5526V19.3539C66.1006 18.991 66.3946 18.697 66.7574 18.697H82.5803C82.9431 18.697 83.2371 18.9909 83.2371 19.3539Z",
    fill: "#B3E59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7788 26.2094H66.7574C66.3946 26.2094 66.1006 25.9154 66.1006 25.5526V19.3539C66.1006 18.991 66.3946 18.697 66.7574 18.697H70.7788C70.4094 18.697 70.1106 18.9959 70.1106 19.3653V25.5428C70.1106 25.9106 70.4094 26.2094 70.7788 26.2094Z",
    fill: "#95D6A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4461 21.1803H24.0148C23.3346 21.1803 22.7832 20.6289 22.7832 19.9487C22.7832 19.2685 23.3346 18.717 24.0148 18.717H39.4461C40.1263 18.717 40.6778 19.2685 40.6778 19.9487C40.6778 20.6289 40.1263 21.1803 39.4461 21.1803Z",
    fill: "#E9EDF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.001 29.6541H90.6163V32.1584H19.001V29.6541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 29.6545H23.1051V32.1587H19V29.6545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.208 14H45.7124V32.1584H43.208V14Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWash);
export default __webpack_public_path__ + "static/media/wash.0ef22f254dd6d750ced7a1587179d579.svg";
export { ForwardRef as ReactComponent };